import { Link } from "react-router-dom";
import "./Menu.css";
import React, { useState, useEffect } from "react";

export default function ({ render }) {
  const [open, setOpen] = useState(true);
  const openF = () => {
    setOpen(!open);
  };

  useEffect(() => {
    setOpen(false);
  }, [render]);

  return (
    <div
      onClick={open ? null : openF}
      className={`menu-cont ${open ? "menu-cont-open" : ""}`}
    >
      <button
        onClick={open ? openF : null}
        className={`menu-burger ${open ? "menu-burger-open" : ""} `}
      >
        <p className={`burger1 ${open ? "burger1open" : ""}`}></p>
        <p className={`burger2 ${open ? "burger2open" : ""}`}></p>
        <p className={`burger3 ${open ? "burger3open" : ""}`}></p>
      </button>

      {open ? (
        <>
          <div className=" ">
            <a onClick={openF} href="#about" className="menu-item">
              {" "}
              QUIÉNES SOMOS 
            </a>
            {/* <p className="littleText">Desde tu perfil podés publicar la búsqueda de tu próximo auto en el <b>MERCADO DE BÚSQUEDAS</b> y recibir en tu mail propuestas de otros usuarios.</p> */}
          </div>

          <div className="column">
          <a onClick={openF} href="#periodistas"className="menu-item">
              {" "}
              PERIODISTAS 
              </a>
            {/* <p className="littleText">Desde tu perfil podés publicar la búsqueda de tu próximo auto en el <b>MERCADO DE BÚSQUEDAS</b> y recibir en tu mail propuestas de otros usuarios.</p> */}
          </div>

          <div  className="column">
          <a onClick={openF} href="#programas"className="menu-item">
              {" "}
              PROGRAMAS 
              </a>
            {/* <p className="littleText">Desde tu perfil podés publicar la búsqueda de tu próximo auto en el <b>MERCADO DE BÚSQUEDAS</b> y recibir en tu mail propuestas de otros usuarios.</p> */}
          </div>

          <div className="column">
          <a onClick={openF} href="#productos" className="menu-item">
              {" "}
              PRODUCTOS 
              </a>
            {/* <p className="littleText">Desde tu perfil podés publicar la búsqueda de tu próximo auto en el <b>MERCADO DE BÚSQUEDAS</b> y recibir en tu mail propuestas de otros usuarios.</p> */}
          </div>

          <div className="column">
          <a onClick={openF} href="#footer" className="menu-item">
              {" "}
              CONTACTO 
              </a>
            {/* <p className="littleText">Desde tu perfil podés publicar la búsqueda de tu próximo auto en el <b>MERCADO DE BÚSQUEDAS</b> y recibir en tu mail propuestas de otros usuarios.</p> */}
          </div>

          
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
